<form [formGroup]="editSOForm" (ngSubmit)="onSubmit()">
  <div class="grid-x align-center">
    <div class="cell large-3 medium-4 small-12">
      <label>Organization Name:</label>
    </div>
    <div class="large-9 medium-8 small-12"><textarea formControlName="organizationName" placeholder="Organization Name"
                                                     class="input-group-custom"></textarea>
      <label class="required-field">* Required Field</label>
      <div class="form-error is-visible" *ngIf="displayServerValidationError('organizationName')">
        <span>{{displayServerValidationError('organizationName')}}</span>
      </div>
      <lib-whitelist-character-error [whitelistFormControl]="organizationName"></lib-whitelist-character-error>
    </div>
  </div>
  <div class="grid-x">
    <div class="cell large-3 medium-4 small-12"><label>Physical Address:</label></div>
    <div class="large-9 medium-8 small-12"><textarea formControlName="streetAddress" placeholder="Street Address"
                                                     class="input-group-custom"></textarea>
      <label class="required-field">* Required Field</label>

      <div class="form-error is-visible" *ngIf="displayAddressValidationError('streetAddress')">
        <span>{{displayAddressValidationError('streetAddress')}}</span>
      </div>
      <lib-whitelist-character-error [whitelistFormControl]="streetAddress"></lib-whitelist-character-error>
    </div>
  </div>
  <div class="grid-x">
    <div class="cell large-3 medium-4 small-12"></div>
    <div class="large-9 medium-8 small-12"><input formControlName="city" placeholder="City"
                                                  class="input-group-custom" maxlength="50">
      <div class="form-error is-visible" *ngIf="displayAddressValidationError('city')">
        <span>{{displayAddressValidationError('city')}}</span>
      </div>
      <lib-whitelist-character-error [whitelistFormControl]="city"></lib-whitelist-character-error>
    </div>
  </div>
  <div class="grid-x">
    <div class="cell large-3 medium-4 small-12"></div>
    <div class="large-9 medium-8 small-12"><input formControlName="state" placeholder="State"
                                                  class="input-group-custom" maxlength="50">
      <div class="form-error is-visible" *ngIf="displayAddressValidationError('state')">
        <span>{{displayAddressValidationError('state')}}</span>
      </div>
      <lib-whitelist-character-error [whitelistFormControl]="state"></lib-whitelist-character-error>
    </div>
  </div>

  <div class="grid-x">
    <div class="cell large-3 medium-4 small-12"></div>
    <div class="large-9 medium-8 small-12"><input formControlName="postalCode" placeholder="Postal Code"
                                                  class="input-group-custom" maxlength="15">
      <div class="form-error is-visible" *ngIf="displayAddressValidationError('postalCode')">
        <span>{{displayAddressValidationError('postalCode')}}</span>
      </div>
      <lib-whitelist-character-error [whitelistFormControl]="postalCode"></lib-whitelist-character-error>
    </div>
  </div>

  <div class="grid-x" style="padding-top: 5px">
    <div class="cell large-3 medium-4 small-12"></div>
    <div class="cell large-9 medium-8 small-12">
      <div class="grid-x">
        <div class="cell">
          <select formControlName="countryName"
                  aria-describedby="Select a Country" (change)="showOtherElement()">
            <option *ngFor="let country of countries" [value]="country.countryCode"
                    [selected]="country.countryCode==this.editSOForm.getRawValue().countryName">
              {{country.countryName}}
            </option>
          </select>
          <label class="required-field">* Required Field</label>
        </div>
        <div class="cell" style="margin-top: 0.5rem"><input formControlName="otherCountry" placeholder="Other.."
                                                            *ngIf="showOtherCountryElement"
                                                            class="input-group-custom" maxlength="20"></div>
        <div class="cell form-error is-visible" *ngIf="displayAddressValidationError('countryName')">
          <span>{{displayAddressValidationError('countryName')}}</span>
        </div>
        <lib-whitelist-character-error [whitelistFormControl]="otherCountry"></lib-whitelist-character-error>
      </div>
    </div>
  </div>

  <div class="grid-x save-cancel-button-group">
    <button class="iana-button-cancel" (click)="cancel()">{{newDelegation ? "Previous" : "Cancel"}}</button>
    <button class="iana-button"  [disabled]="!editSOForm.valid" type="submit">{{newDelegation ? "Next" : "Save"}}</button>
  </div>
</form>
